// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"UJ-z","loadingMedia":"VJ-z","reviewsImagesAndVideos":"WJ-z","limitHeight":"XJ-z"};